import { __rest, __assign } from 'tslib';
import { forwardRef } from 'react';
import { jsx } from '@emotion/react';
import { useTheme } from '../hooks/useTheme.js';

var Box = forwardRef(function (_a, ref) {
    var _b = _a.component, component = _b === void 0 ? "div" : _b, as = _a.as, sx = _a.sx, themeKey = _a.themeKey, props = __rest(_a, ["component", "as", "sx", "themeKey"]);
    var _c = useTheme(), applyTheme = _c.applyTheme, handleStyleProps = _c.handleStyleProps;
    var forwardProps = themeKey
        ? handleStyleProps(__assign({ sx: sx }, props), {
            themeKey: themeKey,
        })
        : __assign({ css: applyTheme({ boxSizing: "border-box", minWidth: 0 }, sx) }, props);
    return jsx(as || component, __assign(__assign({}, forwardProps), { ref: ref }));
});

export { Box };
//# sourceMappingURL=index.js.map
